import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '@modules/shared/shared.module';

import { NewsletterSubscribeComponent } from './components/subscribe.component';
import { NewsletterUnsubscribeComponent } from './components/unsubscribe.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'subscribe',
    pathMatch: 'full',
  },
  {
    path: '',
    data: {
      breadcrumb: {
        label: 'NEWSLETTER',
        link: 'newsletter',
      },
    },
    children: [
      {
        path: 'subscribe',
        data: {
          breadcrumb: {
            label: 'SUBSCRIBE',
            link: 'subscribe',
          },
        },
        component: NewsletterSubscribeComponent,
      },
      {
        path: 'unsubscribe',
        data: {
          breadcrumb: {
            label: 'UNSUBSCRIBE',
            link: 'unsubscribe',
          },
        },
        component: NewsletterUnsubscribeComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, SharedModule],
})
export class NewsletterRoutingModule {}
